export default "__VITE_ASSET__b4aa3336__"